module.exports = __webpack_public_path__ + "img/12_32.f57b1287.png";